import React from 'react';
import { FsDirection } from 'globals/types';
import { Box } from '@material-ui/core';
import FsVectorArrowIcon from 'ui-elements/icons/FsVectorArrow';
import { green, red } from 'globals/colors';
import {
  ButtonTab,
  ItemLabel,
  ItemsWrapperBox,
  ItemValue,
  Percentage,
  PercentageLabel,
  ResultLabel,
  ResultValue,
  ResultWrapperBox,
  Name,
} from './LargeToggleTabButton.style-elements';

interface SingleMarker {
  name: string;
  value: number;
}

interface Effectiveness {
  label?: string;
  percentageValue: number;
  growth: boolean;
}

export interface LargeToggleTabButtonDataProps {
  id: number;
  name: string;
  percentageValue: number;
  effectiveness: Effectiveness;
  markers: SingleMarker[];
}

export interface LargeToggleTabButtonProps
  extends LargeToggleTabButtonDataProps {
  selected: boolean;
  percentageLabel: string;
  onClick: () => void;
}

const LargeToggleTabButton: React.FC<LargeToggleTabButtonProps> = ({
  effectiveness,
  markers,
  percentageLabel,
  percentageValue,
  name,
  selected,
  onClick,
}) => {
  return (
    <ButtonTab selected={selected} onClick={onClick} value>
      <Box display="flex" alignItems="baseline">
        <Percentage>
          {percentageValue}
          <span>%</span>
        </Percentage>
        <PercentageLabel>{percentageLabel}</PercentageLabel>
      </Box>
      <Box marginBottom={1}>
        <Name>{name}</Name>
      </Box>
      <Box display="flex">
        <ItemsWrapperBox>
          <Box paddingTop={1} paddingBottom={1}>
            {markers.map(({ name: markerName, value: markerValue }) => (
              <Box key={markerName} lineHeight={1.4}>
                <ItemLabel component="span">{markerName}</ItemLabel>{' '}
                <ItemValue component="strong">{markerValue}</ItemValue>
              </Box>
            ))}
          </Box>
        </ItemsWrapperBox>
        <ResultWrapperBox>
          <Box paddingTop={1} paddingBottom={1}>
            <Box display="flex" alignItems="center">
              {effectiveness.growth ? (
                <FsVectorArrowIcon
                  direction={FsDirection.UP}
                  color={green.MAIN}
                />
              ) : (
                <FsVectorArrowIcon
                  direction={FsDirection.DOWN}
                  color={red.MAIN}
                />
              )}
            </Box>
            <Box>
              <ResultValue component="span">
                {effectiveness.percentageValue}%
              </ResultValue>{' '}
              <ResultLabel component="strong">
                ({effectiveness.label})
              </ResultLabel>
            </Box>
          </Box>
        </ResultWrapperBox>
      </Box>
      <i className="arrow" />
    </ButtonTab>
  );
};

export default LargeToggleTabButton;
